module.exports = __webpack_public_path__ + "static/media/01.cfc66024.mp4";